import { type FilingCabinetContextData } from '@/Contexts/Authenticated/FilingCabinetContext';
import { type FilingCabinetItem } from '@/Models/FilingCabinet/FilingCabinet';

export default class FilingCabinetStore<T> {
    fcData: FilingCabinetItem;
    _fc: FilingCabinetContextData;

    constructor(initialState: FilingCabinetItem, fcContext: FilingCabinetContextData) {
        this._fc = fcContext;
        this.fcData = initialState;
    }

    get currentState(): T | null {
        if (this.fcData?.state && this.fcData.state !== '') {
            return JSON.parse(this.fcData.state) as T;
        }
        return null;
    }

    initializeState(setState: (state: T) => void, initNew: () => void): void {
        const existingState = this.currentState;
        if (existingState) {
            setState(existingState);
        }
        else {
            initNew();
        }
    }

    updateTitle(title: string): void {
        this.fcData.title = title;
        const newData = { ...this.fcData, title };
        this._fc.add(newData);
    }

    updatePath(path: string): void {
        this.fcData.path = path;
        const newData = { ...this.fcData, path };
        this._fc.add(newData);
    }

    updateState(newState: T): void {
        let oldData = this._fc.getWithID(this.fcData.ID);
        if (oldData == null) {
            return console.error(`FilingCabinetStore could not find FC entry for ID ${this.fcData.ID}`);
        }
        // IMPORTANT: Make sure to add the properties here that can be updated in other updateXXX functions in this class as well (as they might be forgotten due to async updates etc.)
        oldData = { ...oldData, path: this.fcData.path, title: this.fcData.title, state: JSON.stringify(newState) }; // React might otherwise not rerender
        this.fcData = oldData;
        this._fc.add(oldData);
    }
}
